export const dummyPassword: string = new Date().getMilliseconds().toString();
export const mailToVividSupport: string = 'mailto:support@meetvividhealth.com';
